/**
 * sl-pbux.3.1: Three-column CSS Grid container. Accepts leaf components only.
 */
import { createElement, type ReactNode } from 'react';
import { z } from 'zod';

import { VIEW_COMPONENT_TYPES } from '../../../constants/view-component-types';
import type { ViewComponent } from '../../../types/view-component.types';

const configSchema = z.object({
  gap: z.enum(['none', 'sm', 'md', 'lg']).default('md'),
});

const GAP_PX: Record<z.infer<typeof configSchema>['gap'], string> = {
  none: '0',
  sm: '8px',
  md: '16px',
  lg: '24px',
};

export const Grid3Component: ViewComponent = {
  id: VIEW_COMPONENT_TYPES.GRID_3,
  type: 'container',
  name: 'Grid (3 Spalten)',
  icon: createElement(
    'span',
    { style: { fontSize: 'var(--sl-app-font-size-sm)' } },
    '▦'
  ),
  capabilities: [],
  configSchema,
  defaultConfig: { gap: 'md' },
  render({ config, mode }): ReactNode {
    const cfg = config as z.infer<typeof configSchema>;
    return createElement('div', {
      'data-sl-children-slot': 'children',
      'data-sl-mode': mode,
      style: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        gap: GAP_PX[cfg.gap],
      },
    });
  },
  palettePreview() {
    return createElement(
      'div',
      {
        style: {
          padding: 'var(--sl-app-padding-sm)',
          fontSize: 'var(--sl-app-font-size-xs)',
          color: 'var(--streamlain-v2-text-secondary)',
        },
      },
      '▦ Grid 3'
    );
  },
};
